import CryptoJS from "crypto-js";

// AES密钥（与后端保持一致，通过环境变量注入）
const AES_KEY = process.env.VUE_APP_AES_KEY || "JiangHeFlood2024";

/**
 * AES加密
 * @param {string} content - 待加密内容
 * @returns {string} Base64编码的加密字符串
 */
export function encryptAES(content) {
  if (!content) {
    return "";
  }

  try {
    const key = CryptoJS.enc.Utf8.parse(AES_KEY);
    const encrypted = CryptoJS.AES.encrypt(content, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  } catch (error) {
    console.error("AES加密失败:", error);
    throw new Error("密码加密失败，请重试");
  }
}

/**
 * AES解密（前端一般不需要，仅用于测试）
 * @param {string} encryptedContent - Base64编码的加密字符串
 * @returns {string} 解密后的原始字符串
 */
export function decryptAES(encryptedContent) {
  if (!encryptedContent) {
    return "";
  }

  try {
    const key = CryptoJS.enc.Utf8.parse(AES_KEY);
    const decrypted = CryptoJS.AES.decrypt(encryptedContent, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("AES解密失败:", error);
    throw new Error("密码解密失败");
  }
}

/**
 * 验证密码复杂度
 * @param {string} password - 待验证的密码
 * @returns {object} { valid: boolean, message: string }
 */
export function validatePasswordComplexity(password) {
  if (!password) {
    return { valid: false, message: "密码不能为空" };
  }

  // 长度验证：8-20位
  if (password.length < 8 || password.length > 20) {
    return { valid: false, message: "密码长度必须为8-20位" };
  }

  // 必须包含数字
  if (!/\d/.test(password)) {
    return { valid: false, message: "密码必须包含数字" };
  }

  // 必须包含小写字母
  if (!/[a-z]/.test(password)) {
    return { valid: false, message: "密码必须包含小写字母" };
  }

  // 必须包含大写字母或特殊字符
  const hasUpperCase = /[A-Z]/.test(password);
  const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);

  if (!hasUpperCase && !hasSpecialChar) {
    return {
      valid: false,
      message: "密码必须包含大写字母或特殊字符(!@#$%^&*等)",
    };
  }

  return { valid: true, message: "密码符合要求" };
}

/**
 * 获取密码复杂度要求提示文本
 * @returns {string} 密码要求说明
 */
export function getPasswordRequirements() {
  return `密码必须满足以下要求：
1. 长度8-20位
2. 包含数字
3. 包含小写字母
4. 包含大写字母或特殊字符(!@#$%^&*等)

示例合格密码：
• JiangHe123（包含大写、小写、数字）
• jianghe@123（包含小写、数字、特殊字符）
• FLOOD2024!（包含大写、数字、特殊字符）`;
}

export default {
  encryptAES,
  decryptAES,
  validatePasswordComplexity,
  getPasswordRequirements,
};
